import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventSettingsComponent } from '../events/settings/event-settings.component';
import { AuthGuard } from '../shared/auth/auth-guard.service';
import { WlCanDeactivateRouteGuard } from '../shared/route';
import { EventsV4DashboardComponent } from './dashboard/events-v4-dashboard.component';
import { EventSettingsV4Component } from './settings/event-v4-settings.component';

const routes: Routes = [
  { title: 'events.dashboard.title', path: '', component: EventsV4DashboardComponent, canActivate: [AuthGuard] },
  { path: ':id', component: EventSettingsV4Component, canActivate: [AuthGuard], canDeactivate: [WlCanDeactivateRouteGuard] },
  {
    title: 'common.settings',
    path: ':id/settings',
    component: EventSettingsV4Component,
    canActivate: [AuthGuard],
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'events.dashboard.component.pending-registrations-label',
    path: ':id/registrations/pending',
    component: EventSettingsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EventsV4RoutingModule {}
